var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShuffle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7865 1.04253C10.3325 0.895031 9.84494 1.14347 9.69744 1.59744L6.44798 11.5982C6.30048 12.0522 6.54892 12.5398 7.00289 12.6873L13.9897 14.9575C14.4437 15.105 14.9313 14.8565 15.0788 14.4026L18.3283 4.40176C18.4758 3.9478 18.2273 3.46021 17.7734 3.3127L10.7865 1.04253Z",
    fill: "#FFF7EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71675 1.35271L5.46661 1.35271C4.98927 1.35271 4.60232 1.73966 4.60232 2.21699V12.7324C4.60232 13.2098 4.98927 13.5967 5.4666 13.5967L6.55638 13.5967C5.65927 13.2281 5.18436 12.2243 5.48902 11.2866L8.71675 1.35271Z",
    fill: "#FFF7EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59397 2.27218L0.597439 3.24581C0.14347 3.39331 -0.104969 3.8809 0.0425345 4.33487L3.29199 14.3357C3.43949 14.7896 3.92708 15.0381 4.38105 14.8906L5.28614 14.5965C4.33658 14.5057 3.59397 13.7058 3.59397 12.7325V2.27218Z",
    fill: "#FFF7EB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuffle);
export default __webpack_public_path__ + "static/media/shuffle.97fc8cc56fa7db23237eae702a1f246b.svg";
export { ForwardRef as ReactComponent };